module.exports = __webpack_public_path__ + "media/images/sp/brands/aqua/store_funabashi-7a40850aa32118efe8f16c05f0600225.jpg";